export enum AnnouncementSeverity {
  Information = 'Information',
  Warning = 'Warning',
  Critical = 'Critical',
}
